import { useCallback, useRef, useState } from "react"

// The ref stops a press that lands before `busy` renders; `sending` waits for the request, so a failed check shows no spinner.
export const useOnePress = () => {
  const out = useRef(false)
  const [busy, setBusy] = useState(false)

  const run = useCallback(
    async (action: (sending: () => void) => Promise<unknown>) => {
      if (out.current) return
      out.current = true
      try {
        await action(() => setBusy(true))
      } finally {
        out.current = false
        setBusy(false)
      }
    },
    []
  )

  return { busy, run }
}
